import script from "./AdvertEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertEdit.vue?vue&type=script&setup=true&lang=js"

import "./AdvertEdit.vue?vue&type=style&index=0&id=52d51886&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d51886"]])

export default __exports__